import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ConfirmProvider } from "@/components/ConfirmDialog";
import { ImageLightboxProvider } from "@/components/ImageLightbox";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import Editor from "@/pages/Editor";
import Locked from "@/pages/Locked";
import Account from "@/pages/Account";
import { BillingSuccess, BillingCancel } from "@/pages/Billing";
import AdminDashboard from "@/pages/AdminDashboard";
import AcceptInvite from "@/pages/AcceptInvite";
import Boards from "@/pages/Boards";
import BoardEditor from "@/pages/BoardEditor";
import Coach from "@/pages/Coach";

function LockGuard({ children }) {
  const { user } = useAuth();
  if (!user) return children;
  if (user.account_type === "collaborator") return children;
  const lockedStatuses = ["locked"];
  if (lockedStatuses.includes(user.subscription_status) && !user.comp_granted) {
    return <Navigate to="/locked" replace />;
  }
  return children;
}

function App() {
  return (
    <div className="App font-ui">
      <AuthProvider>
        <ConfirmProvider>
          <ImageLightboxProvider>
            <BrowserRouter>
              <Toaster position="bottom-right" toastOptions={{ style: { fontFamily: "IBM Plex Sans" } }} />
              <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<Signup />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/invite/:token" element={<AcceptInvite />} />

                <Route path="/billing/success" element={<BillingSuccess />} />
                <Route path="/billing/cancel" element={<BillingCancel />} />

                <Route path="/locked" element={<ProtectedRoute><Locked /></ProtectedRoute>} />
                <Route path="/account" element={<ProtectedRoute><Account /></ProtectedRoute>} />

                <Route path="/app" element={<ProtectedRoute><LockGuard><Dashboard /></LockGuard></ProtectedRoute>} />
                <Route path="/app/scripts/:scriptId" element={<ProtectedRoute><LockGuard><Editor /></LockGuard></ProtectedRoute>} />
                <Route path="/app/boards" element={<ProtectedRoute><LockGuard><Boards /></LockGuard></ProtectedRoute>} />
                <Route path="/app/boards/:boardId" element={<ProtectedRoute><LockGuard><BoardEditor /></LockGuard></ProtectedRoute>} />
                <Route path="/app/coach" element={<ProtectedRoute><LockGuard><Coach /></LockGuard></ProtectedRoute>} />

                <Route path="/admin" element={<ProtectedRoute role="admin"><AdminDashboard /></ProtectedRoute>} />

                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </BrowserRouter>
          </ImageLightboxProvider>
        </ConfirmProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
